import React from "react";
import "./Plans.css";
import { plansData } from "../../data/plansData";
import whiteTick from "../../assets/whiteTick.png";

const Plans = () => {
	return (
		<section className="plans-container" id="plans">
			<div className="blur plans-blur-1"></div>
			<div className="blur plans-blur-2"></div>
			
			<div className="plans-header">
				<h2 className="stroke-text">Ready to Start</h2>
				<h2 className="outfit">Your Journey</h2>
				<h2 className="stroke-text">Now With Us</h2>
			</div>

			<div className="plans-grid">
				{plansData.map((plan, i) => (
					<div className="plan-card glass-card" key={i}>
						<div className="plan-icon-container">
							{plan.icon}
						</div>
						<h3 className="plan-name outfit">{plan.name}</h3>
						<div className="plan-price">
							<span className="currency">Rs.</span>
							<span className="amount">{plan.price}</span>
						</div>

						<div className="plan-features">
							{plan.features.map((feature, j) => (
								<div className="feature-item" key={j}>
									<img src={whiteTick} alt="tick" />
									<span>{feature}</span>
								</div>
							))}
						</div>

						<div className="plan-footer">
							<span className="more-benefits">See more benefits</span>
							<a href="tel:+9779863032963" className="btn plan-btn">Join Now</a>
						</div>
					</div>
				))}
			</div>
		</section>
	);
};

export default Plans;
